module.exports = __webpack_public_path__ + "assets/custom.f3d94933.svg";